import type { QueryClient } from "@tanstack/react-query"
import type { WsStreamMessage } from "@/shared/api/generated-social"
import { wsBridge, wsStore, wsUserId } from "@/shared/api/websocket"
import { onAppActive } from "@/shared/lib/platform"
import { streamKeys } from "../model/keys"
import { appendStreamMessage, setStreamHasNew } from "./cache"

function syncStream(): void {
	const { queryClient } = wsBridge.getContext()
	if (!queryClient || !wsUserId()) return
	queryClient.invalidateQueries({ queryKey: streamKeys.all })
}

function handleStreamMessage(
	payload: WsStreamMessage,
	queryClient: QueryClient,
): void {
	const userId = wsUserId()
	if (!userId) return

	const isOwn = payload.message.author.id === userId
	appendStreamMessage(queryClient, {
		...payload.message,
		is_own: isOwn,
		starred: false,
	})
	if (isOwn) return

	const viewing = queryClient
		.getQueryCache()
		.findAll({ queryKey: streamKeys.messages(), type: "active" })
	if (viewing.length === 0) setStreamHasNew(queryClient, true)
}

export function registerStreamEvents(): void {
	wsStore.on("state", ({ isConnected }) => {
		if (isConnected) syncStream()
	})
	onAppActive(syncStream)
	wsBridge.subscribe("stream.message", handleStreamMessage)
}
